import Paginator from './index.js';
import { setDataAttributes } from '../dataSetter';

export default class ComponentLister extends Paginator {
  constructor(prefix = 'complex', sComponentMethod = 'onGetJSONData', storeList = {}) {
    super(sComponentMethod);
    this.setStoreList(storeList);
    this.listElement = null;
    this.btnMore = null;
    this.prefix = prefix;
    this.obItemBindCallback = null;
    this.replaceMode = false;
  }

  /** true/false - заменяет содержимое / вставляет в конец */
  setReplaceMode(mode) {
    this.replaceMode = mode;

    return this;
  }

  findBtnMore() {
    const prefix = this.prefix;
    const btnMore = document.querySelector(`[data-nika-${prefix}-list-more]`);
    this.btnMore = btnMore;

    return btnMore;
  }

  findListElement() {
    const prefix = this.prefix;
    const listElement = document.querySelector(`[data-nika-${prefix}-list]`);
    this.listElement = listElement;

    return listElement;
  }

  updateBtnMoreData(btnMore, response) {
    if (!response.pagination) return;
    if (response.pagination.next <= 0) {
      btnMore.style.display = 'none';
    } else {
      btnMore.style.display = 'flex';
      btnMore.setAttribute('data-next-page', response.pagination.next);
      const leftSpan = btnMore.querySelector('span[data-left]');
      if (leftSpan) {
        leftSpan.textContent = response.pagination.left;
      }
      const countSpan = btnMore.querySelector('span[data-count]');
      if (countSpan) {
        countSpan.textContent = response.pagination.count;
      }
    }
  }

  setItemBindCallback(obCallback) {
    this.obItemBindCallback = obCallback;

    return this;
  }

  setComplexSuccessRequestCallback() {
    const prefix = this.prefix;
    const listElement = this.listElement;
    const btnMore = this.btnMore;
    const setBtnMoreDataFn = this.updateBtnMoreData;
    const setItemBindFn = this.obItemBindCallback;

    this.setSuccessRequestCallback(function successRequest(response) {
      let replaceMode = this.replaceMode;
      if (response.items && response.items.length === 0) {
        listElement.innerHTML = '';
      }

      /*
      Этого нет в Комплексах
      const totalEl = document.querySelector(`[data-nika-${prefix}-total-count]`);
      if (totalEl) {
        totalEl.textContent = response.total;
      }
      */
      const notFound = document.querySelector(`.catalog-list__not-found`);
      if (notFound) {
        if (response.total) {
            notFound.classList.remove('catalog-list__not-found_shown');
        } else {
            notFound.classList.add('catalog-list__not-found_shown');
        }
      }
      for (let i in response.items) {
        let itemExample = document.querySelector(`[data-nika-${prefix}-item]`).cloneNode(true);

        let item = response.items[i];

        let itemBind = setItemBindFn(item);

        /** Временный костыль для очистки свойств */
        const properties = itemExample.querySelectorAll(`[data-nika-${prefix}-item-property]`);
        if (properties) {
            Array.from(properties).map(e => (e.style.display = 'none'));
        }

        let newItemElement = setDataAttributes(itemBind, `${prefix}-item`, itemExample);

        /** Временный костыль для карточки комплекса */
        if (newItemElement.href) {
          newItemElement.href = newItemElement.href.replace(/\/[^\/]*$/, `/${item.slug}`);
        }

        // let linkElement = newItemElement.querySelector('.category-card .product-card__btn');
        newItemElement.href = `/catalog/complex/${item['slug']}`;

        if (replaceMode) {
          listElement.innerHTML = '';
          replaceMode = false;
        }

        /*
        Видимо осталось от карточки с недвижимостью.
        itemExample.querySelector('.product-card__list-text-area').innerHTML = item['area_text'];
        */

        listElement.appendChild(newItemElement);
      }

      setBtnMoreDataFn(btnMore, response);
    }, prefix, listElement, btnMore, setBtnMoreDataFn, setItemBindFn, this.replaceMode);
  }

  /** force=true отправляет запрос сразу после инициализации вместо навешивания на кнопку */
  init(force) {
    const _self = this;
    const btnMore = _self.findBtnMore();
    const listElement = _self.findListElement();
    const replaceMode = _self.replaceMode;

    if (listElement && btnMore) {
      /**
       * Получение json с пагинацией.
       */
      var runFn = function() {
        _self.onGetJSONData(
          replaceMode ? 1 : btnMore.getAttribute('data-next-page'),
          btnMore.getAttribute('data-per-page')
        )
      };
      _self.setComplexSuccessRequestCallback();
      if (force) {
        runFn();
        return;
      }
      btnMore.addEventListener('click', runFn, false);
    }
  }
}
